import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unusableFieldsErrorTitle: {
		id: 'servicedesk-widget-settings.content.error-sections.fields-error.unusable-fields-error-title',
		defaultMessage: 'Update request type',
		description:
			'Title for the error message displayed when the user selects a request type which has fields that are not supported by the widget',
	},
	unusableFieldsErrorDescription: {
		id: 'servicedesk-widget-settings.content.error-sections.fields-error.unusable-fields-error-description',
		defaultMessage:
			"We can't display the following {length, plural, one {field} other {fields}} on the service project widget",
		description:
			'Description for the error message displayed when the user selects a request type which has fields that are not supported by the widget',
	},
	unusableFieldsErrorFixInstruction: {
		id: 'servicedesk-widget-settings.content.error-sections.fields-error.unusable-fields-error-fix-instruction',
		defaultMessage:
			"You can remove the {length, plural, one {field, or make it optional. If you make it optional, it won't display on the widget.} other {fields, or make them optional. If you make them optional they won't display on the widget.}}",
		description:
			'Instructions for fixing the error message displayed when the user selects a request type which has fields that are not supported by the widget',
	},
	optionalUnusableFieldsErrorTitle: {
		id: 'servicedesk-widget-settings.content.error-sections.fields-error.optional-unusable-fields-error-title',
		defaultMessage: 'This request type has unsupported fields',
		description:
			'Title for the error message displayed when the user selects a request type which has optional fields that are not supported by the widget',
	},
	optionalUnusableFieldsErrorDescription: {
		id: 'servicedesk-widget-settings.content.error-sections.fields-error.optional-unusable-fields-error-description',
		defaultMessage:
			"If you embed this request type, the following {length, plural, one {field} other {fields}} won't display on the widget",
		description:
			'Description for the error message displayed when the user selects a request type which has optional fields that are not supported by the widget',
	},
	optionalUnusableFieldsErrorFixInstruction: {
		id: 'servicedesk-widget-settings.content.error-sections.fields-error.optional-unusable-fields-error-fix-instruction',
		defaultMessage:
			'You can remove {length, plural, one {it} other {them}} from the request type, or embed the form as is.',
		description:
			'Instructions for fixing the error message displayed when the user selects a request type which has optional fields that are not supported by the widget',
	},
	optionalUnusableFieldsErrorAction: {
		id: 'servicedesk-widget-settings.content.error-sections.fields-error.optional-unusable-fields-error-action',
		defaultMessage: 'Embed form as is',
		description:
			'Action button to embed the form as is when the user selects a request type which has optional fields that are not supported by the widget',
	},
});
